<template>
  <ConfigPage :max-width="900">
    <ConfigItem
      :title="
        __('Gestão de tipos de documentos solicitados por subtipo de sinistro')
      "
      :description="
        __(
          'Os tipos de documentos devererão ser configuradas de acordo com cada subtipo de sinistro'
        )
      "
      class="mt-10"
    >
      <v-card flat>
        <v-alert type="warning" class="mb-4" text outlined>
          {{
            __(
              "Todos os parâmetros devem selecionar um tipo de sinistro e vincular tipos de documentos solicitados a cada subtipo, elas devem ser coerentes com o propósito do parâmetro"
            )
          }}
        </v-alert>
      </v-card>
    </ConfigItem>

    <ConfigItem>
      <v-card outlined>
        <v-list>
          <v-list-item
            v-for="type in leadTypes"
            :key="type.id"
            link
            class="primary--text"
            :to="{
              name: 'configs.leads.requested_documents_types_by_lead_subtype.subtype',
              params: { lead_type_id: type.id },
            }"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ type.description }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="primary">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>

          <v-list-item v-if="!leadTypes.length">
            <v-list-item-content>
              <v-list-item-title class="text--disabled">
                {{ __("Nenhum tipo de sinistro disponível") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </ConfigItem>
  </ConfigPage>
</template>

<script>
import ConfigPage from "@/layouts/configs/ConfigPage";
import ConfigItem from "@/layouts/configs/ConfigItem";
import {
  indexManagementCategories,
  indexDefaultCategories,
  updateDefaultCategory,
} from "@/services/config/attachment_categories";
import { index as indexLeadTypes } from "@/services/lead_types";
import i18n from "@/mixins/i18n";

export default {
  mixins: [i18n],
  components: { ConfigPage, ConfigItem },
  data() {
    return {
      i18n_prefix: "settings",
      fetching: false,
      categories: [],
      parameters: [],
      leadTypes: [],
    };
  },

  methods: {
    async handleParameterChange(parameterName, attachment_category_id) {
      this.parameters = this.parameters.map((filterParameter) => {
        if (filterParameter.parameter === parameterName) {
          filterParameter.attachment_category_id = attachment_category_id;
        }
        return filterParameter;
      });

      await updateDefaultCategory({
        config_default_attachment_category: {
          parameter: parameterName,
          attachment_category_id,
        },
      });
    },

    async getData() {
      this.fetching = true;
      try {
        const [response_categories, response_parameters, response_leadTypes] =
          await Promise.all([
            indexManagementCategories(),
            indexDefaultCategories(),
            indexLeadTypes(),
          ]);

        this.categories = response_categories;
        this.parameters = response_parameters;
        this.leadTypes = response_leadTypes;
      } finally {
        this.fetching = false;
      }
    },
  },

  created() {
    this.getData();
  },
};
</script>
